// @mui
import { Stack, Typography, Box } from '@mui/material';
// hooks
import useAuth from '../../../hooks/useAuth';
import useLocales from '../../../hooks/useLocales';
// routes
// assets
import Image from '../../../components/Image';

// ----------------------------------------------------------------------

export default function NavbarDocs() {
  const { user } = useAuth();

  const { translate } = useLocales();

  return (
    <Stack
      spacing={3}
      sx={{ px: 5, pb: 5, mt: 10, width: 1, textAlign: 'center', display: 'block' }}
    >
      {/* <DocIllustration sx={{ width: 1 }} /> */}
      <Box sx={{ width: 280, height: 160 }}>
        {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.0"
        width="100%"
        height="100%"
        viewBox="0 0 1051 508"
        id="svg3633">
        <defs
          id="defs3635" />
        <g
          transform="translate(-17.4283,-607.43003)"
          id="layer1">
          <g
            transform="translate(17.716531,17.66027)"
            id="g3646">
            <path
              d="M 198.87138,885.37797 C 165.70497,875.19471 159.03837,846.56157 161.03835,814.88402 L 208.98241,814.88402 C 208.98241,836.76165 209.92688,855.10041 236.26,855.10041 C 252.42653,855.10041 260.37094,844.66716 260.37094,829.13947 C 260.37094,787.96202 163.9272,785.42313 163.9272,717.39033 C 163.9272,681.60724 181.0382,653.09634 239.42666,653.09634 C 286.09296,653.09634 309.25947,673.99617 306.09281,721.79029 L 259.42651,721.79029 C 259.42651,704.6904 256.59318,687.30719 237.20443,687.30719 C 221.70456,687.30719 212.4824,695.84602 212.4824,711.657 C 212.4824,755.05671 308.92613,751.25673 308.92613,823.13953 C 308.92613,862.73922 289.48182,878.96687 265.70422,885.37797 L 198.87138,885.37797"
              fill="#76777a"
              fillRule="nonzero"
              stroke="none"
              id="path3439" />
            <path
              d="M 425.53636,727.18469 C 425.86969,705.9626 422.36975,687.30719 396.98101,687.30719 C 367.14791,687.30719 367.14791,727.50691 367.14791,771.8399 C 367.14791,843.37825 374.14788,856.0615 401.42543,856.0615 C 409.36983,856.0615 417.92533,854.15598 425.20303,851.61153 L 425.20303,800.95634 L 399.20324,800.95634 L 399.20324,765.82329 L 473.14713,765.82329 L 473.14713,881.71129 C 468.03606,882.70017 460.03614,884.07239 450.98062,885.37797 L 368.98124,885.37797 C 324.53713,874.32247 318.59271,839.16164 318.59271,769.31772 C 318.59271,711.657 321.4816,653.09634 399.81434,653.09634 C 446.81401,653.09634 475.98046,679.3795 473.14713,727.18469 L 425.53636,727.18469"
              fill="#76777a"
              fillRule="nonzero"
              stroke="none"
              id="path3441" />
            <path
              d="M 563.64645,653.09634 C 605.53505,653.00188 628.42374,669.38511 631.5904,706.16263 L 631.5904,721.79029 L 584.9241,721.79029 C 584.97962,705.12375 580.81301,687.30719 561.42426,687.30719 C 545.86883,687.30719 536.64667,695.84602 536.64667,711.657 C 536.64667,751.77338 619.0905,751.56228 631.5904,808.06184 L 631.5904,841.17829 C 626.47932,867.91697 609.70169,880.0502 589.92405,885.37797 L 523.09122,885.37797 C 489.92481,875.19471 483.25816,846.56157 485.25814,814.88402 L 533.20224,814.88402 C 533.20224,836.76165 534.14667,855.10041 560.47984,855.10041 C 576.64637,855.10041 584.59077,844.66716 584.59077,829.13947 C 584.59077,787.96202 488.09147,785.42313 488.09147,717.39033 C 488.09147,681.60724 505.25799,653.22413 563.64645,653.09634"
              fill="#76777a"
              fillRule="nonzero"
              stroke="none"
              id="path3443" />
            <path
              d="M 17.4283,890.88901 L 726.08972,890.88901 L 726.08972,885.37797 L 17.4283,885.37797 L 17.4283,890.88901 z "
              fill="#f69138"
              fillRule="nonzero"
              stroke="none"
              id="path3445" />
            <path
              d="M 631.5904,938.13311 L 637.09037,938.13311 L 637.09037,607.43003 L 631.5904,607.43003 L 631.5904,938.13311 z "
              fill="#f69138"
              fillRule="nonzero"
              stroke="none"
              id="path3447" />
          </g>
        </g>
      </svg> */}
        <Image
          ml={-2}
          visibleByDefault
          disabledEffect
          src={require('../../../lvs_logo_cropped.png')}
          alt="LVS"
          width="230"
          //ratio="16/9"
          maxWidth={230}
        />
      </Box>

      <div>
        <Typography gutterBottom variant="subtitle1">
          {translate('docs.hi')}, {user?.userName}
        </Typography>
        {/* <Typography variant="body2" sx={{ color: 'text.secondary', whiteSpace: 'pre-line' }}>
          {translate('docs.description')}
        </Typography> */}
      </div>

      {/* <Button href={PATH_DOCS} target="_blank" rel="noopener" variant="contained">
        {translate('docs.documentation')}
      </Button> */}
    </Stack>
  );
}
